import React, { useState } from 'react';
import './ForgotPassword.css';

interface ForgotPasswordProps {
  onBack?: () => void;
}

const ForgotPassword: React.FC<ForgotPasswordProps> = ({ onBack }) => {
  const [email, setEmail] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // TODO: Implement password recovery logic
    console.log('Password recovery:', { email });
  };

  return (
    <div className="login-container">
      <div className="login-logo">
        <img src="/logo.svg" alt="A2K CRM" className="logo-image" />
      </div>
      
      <div className="login-card">
        <h1 className="login-title">Восстановление пароля</h1>
        
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <input
              type="email"
              placeholder="Ваш email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="form-input"
              required
            />
          </div>
          
          <button type="submit" className="login-button">
            Запросить восстановление
          </button>
        </form>
        
        <a href="#" className="forgot-password" onClick={(e) => {
          e.preventDefault();
          if (onBack) onBack();
        }}>
          Вернуться назад
        </a>
      </div>
    </div>
  );
};

export default ForgotPassword;









